import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const WithInformedHealthConditionsComparisonAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    const series = [
        {
            name: 'Informadas',
            data: chartData?.withInformedHealthConditionsComparisonAnual?.map(item => item.attended)
        },
        {
            name: 'Diferença',
            data: chartData?.withInformedHealthConditionsComparisonAnual?.map(item => item.difference)
        },
        {
            name: 'Total',
            data: chartData?.withInformedHealthConditionsComparisonAnual?.map(item => item.total)
        }
    ];

    const categories = chartData?.withInformedHealthConditionsComparisonAnual?.map(item => getYearLabel(item.ano));

    return (
        <SimpleBars
            title={'Comparação de Condições de Saúde Informadas (Anual)'}
            horizontal={false}
            subtitles={categories}
            series={series}
            stacked
            showDataLabels={false}
        />
    );
};
